import { FC } from "react";
import styled from "styled-components";

interface NotificationProps {
  status: string;
  href?: string;
  isShowLink?: boolean;
}

interface Obj {
  [key: string]: string;
}

const StyledNotification = styled.div`
  text-align: center;
`;

const StyledBondMessage = styled.p`
  margin: 0;
  font-size: 16px;
  color: #000000;
  font-weight: 400;
  line-height: 27px;
  text-align: center;
`;

const StyledErrorMessage = styled.a`
  font-size: 20px;
  color: #000000;
  margin-bottom: 26px;
  line-height: 22px;
  text-decoration: underline;

  color: var(--primary) !important;

  &:hover {
    text-decoration: none;
  }
`;

const Notification: FC<NotificationProps> = (props): JSX.Element => {
  const { status, href = "/", isShowLink = false } = props;
  const messages: Obj = {
    UNDERWRITING_REVIEW: "Our agents will contact you shortly...",
    SIGNATURE_REQUIRED: "We will be in touch shortly.",
    REMARKET: "Our agents will contact you shortly...",
    BOND_ISSUE_READY: "Please wait while we're issuing your bond...",
    UNDERWRITING_INFO_REQUIRED: "Our agents will contact you shortly...",

    // This is counter-intuitive.  If PAYMENT_REQUIRED, we weren't able to complete payment. See GIGSBM-1322.
    PAYMENT_REQUIRED: "Payment is not available for this bond at this time. Please reach out to our team to complete purchasing this bond",
  };

  return (
    <StyledNotification>
      {messages[status] ? (
        <StyledBondMessage>{messages[status] || ""}</StyledBondMessage>
      ) : (
        <StyledBondMessage>Something went wrong...</StyledBondMessage>
      )}
      {isShowLink ? (
        <StyledErrorMessage href={href}>
          Back to the Main page
        </StyledErrorMessage>
      ) : (
        <></>
      )}
    </StyledNotification>
  );
};

export default Notification;
